export const formatDate = isoString => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toISOString().split('T')[0]; // "2025-05-28"
};

export const formatDateView = isoString => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const day = String(date.getDate() + 1).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
